<template>
  <v-dialog persistent :value="addModal" width="850">
    <v-card>
      <popup-heading 
      title="ADD LOCATION" 
      subtitle="Add New Location.">
        <template slot="action">
          <v-btn
            depressed
            @click="closeModal()"
            fab 
            color="white"
            :class="$vuetify.breakpoint.width > 960 ? 'ml-0 mr-2' : 'ml-2'"
          >
            <v-icon dark class="primary--text">close</v-icon>
          </v-btn>
          <v-btn
            @click="addLocations()"
            depressed
            v-if="$store.getters.is_unoapp || $store.getters.is_superadmin || $store.getters.is_corporate"
            fab 
            color="white"
            :class="$vuetify.breakpoint.width > 960 ? 'ml-0 mr-0' : 'ml-0'"
          >
            <v-icon dark class="primary--text">check</v-icon>
          </v-btn>
        </template>
      </popup-heading>
        <v-layout  justify-center>
          <v-flex class="sm12 md12">
            <v-card-text class="pop-header-fixed-content popup-height px-5">
              <v-form ref="addForm" lazy-validation>
                <table class="resource-table" width="100%">
                  <tr v-bind:key="'resource' + index " v-for="(location, index) in form.locations">
                    <td>
                      <v-text-field
                        class=""
                        v-model="location.name"
                        label="Business name"
                        :rules="fieldRequired"
                      ></v-text-field>
                    </td>
                    <td width="200px">
                        <v-text-field
                        class=""
                        v-model="location.ref_id"
                        label="Ref. id (optional)"
                      ></v-text-field>
                    </td>
                    <td width="50px;" class="text-xs-right">
                      <v-btn
                        @click="removeObj(index)"
                        slot="activator"
                        fab 
                        small
                        dark 
                        color="primary"
                        :class="$vuetify.breakpoint.width > 960 ? 'ml-0 mr-2 xs-small' : 'ml-3 xs-small'"
                      >
                        <v-icon dark>fas fa-minus</v-icon>
                      </v-btn>
                    </td>
                  </tr>
                </table>
              </v-form>

              <div class="py-2 text-xs-right">
                <v-btn
                  @click="addNewObj()"
                  fab    
                  dark 
                  color="primary"
                >
                  <v-icon dark>add</v-icon>
                </v-btn>
              </div>
            </v-card-text>
          </v-flex>
        </v-layout>
      </v-card>
    </v-dialog>
</template>
<script>
import Env from '@/env';
import AuthApi from '@/components/Controllers/AuthApis';
import Helper from '@/components/Controllers/Helpers';
import { mapActions, mapGetters } from 'vuex';
import { some, isEmpty } from 'lodash';

export default {
  data() {
    return {
      numericValidation: [
        (v) => !!v || 'Field is required',
        (v) => /^[0-9]+$/.test(v) || 'Field must be numeric'
      ],
      fieldRequired: [
        v => !!v || 'Field is required.',
      ],
      form: {
        locations: [],
      },
    };
  },
  computed: {
    ...mapGetters({
      addModal: 'location/add',
    }),
  },
  watch: {
    'addModal': function(val){
      if(val){
        this.addNewObj();
      }
    }
  },
  mounted() {
    this.closeModal();
  },
  methods: {
     /**
     * Add new object
     */
    addNewObj() {
      this.form.locations.push({
        business: this.$store.getters.getLoggedInUserSelectedBusinessId,
        name: '',
        ref_id: '',
      });
    },

    /**
     * Remove obj
     */
    removeObj(index) {
       this.form.locations.splice(index, 1);
    },

    /**
     * Fetch all location
     */
    fetchLocations() {
      const url = `${Env.url}/api/v1/locations/${ this.$store.getters.getLoggedInUserSelectedBusinessId }`;
      AuthApi.getApi(url)
      .then((res) => {
        this.setList(res.data.payload);
      })
      .catch((err) => {
        console.log('Unable to fetch locations.')
      });
    },
    /**
     * Add new location
     */
    addLocations() {
      if (this.$refs.addForm.validate()) {
        this.spinner(true);
        const url = `${Env.url}/api/v1/locations`;
        AuthApi.postApi(url, this.form)
          .then((res) => {
            this.snackbar({
              text: res.data.msg,
              timeout: 4000,
              open: true,
            });
            this.fetchLocations();
            this.closeModal();
          })
          .catch((err) => {
            this.snackbar({
              text: err.response.data.msg,
              timeout: 4000,
              open: true,
            });
            this.spinner(false);
          });
      }
    },
  
   
    /**
     * Close update modal and remove assign values in form
     */
    closeModal() {
      // Rest form values
      this.form.locations = [];
      this.setAdd(false);
      this.spinner(false);
    },


    ...mapActions({
      setAdd: 'location/setAdd',
      setList: 'location/setList',
      spinner: 'spinner/spinnerStatus',
      snackbar: 'snackbar/snackbar',
    }),
  },
};
</script>
